import styled from 'styled-components';
import { Col as RawCol, Card, mediaQueries, size, colors } from '@everlywell/leaves';

const Col = styled(RawCol)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  row-gap: ${size.xl2}px;
  column-gap: 1rem;
  align-items: stretch;
  padding-bottom: ${size.xl2}px;

  ${mediaQueries.forTabletVerticalUp} {
    grid-template-columns: repeat(auto-fill, minmax(248px, 1fr));
    column-gap: 2rem;
  }

  ${mediaQueries.forDesktopUp} {
    column-gap: 1.875rem;
  }

  ${mediaQueries.forTabletVerticalDown} {
    row-gap: ${size.lg}px;
  }
`;

const CardWrapper = styled.div``;

const ProductCard = styled(Card.Product)`
  height: 100%;
`;

export { Col, ProductCard, CardWrapper };
